export const LOGO: string = 'fireris.png';
export const RAMED_ENABLED: boolean = false;
export const PROFILE_PLACEHOLDER = '../../../assets/images/profile.jpg';
export const DEFAULT_CENTER_NAME = 'Default Center - Local';


